export default "__VITE_ASSET__b4992144__"